// extracted by mini-css-extract-plugin
export default {"projetosfera_logo_branco_v":"evaluation-navbar_projetosfera_logo_branco_v__zOoj1"};